import Control from './Control';

const Questionnaire = ({ utilities }) => {
  const {
    program,
    dispatch,
    getCurrentPage,
    getPreviousPage,
    getNextPage,
  } = utilities;

  const {
    prompts,
    program: { skippable },
  } = getCurrentPage();

  const
    sortedPrompts = prompts.sort(
      (
        { control: control1 },
        { control: control2 }
      ) => control1 > control2
    ),
    nextPage = getNextPage(true),
    previousPage = getPreviousPage()
  ;

  return (
    <form className="questionnaire">
        { sortedPrompts.map(({ id }, index) => (
          <Control
            id={ id }
            utilities={ utilities }
            setSelection={
              (selections) => dispatch({
                type: 'setSelection',
                value: {
                  prompt: id,
                  selections: selections,
                },
              })
            }
            key={ index }
          />
        )) }

        <fieldset className="buttons top">
          { program.debug ? (
            <button
              type="button"
              aria-disabled={ previousPage !== undefined ? 'false' : 'true' }
              disabled={ previousPage !== undefined ? false : true }
              className={ previousPage !== undefined ? '' : 'disabled' }
                onClick={
                () => dispatch({
                  type: 'navigate',
                  value: -1,
                })
              }
            >Back</button>
          ) : undefined }

          { program.debug ? (
            <button
              type="button"
              onClick={
                () => dispatch({
                  type: 'reset',
                })
              }
            >Reset</button>
          ) : undefined }

          <button
            type="button"
            aria-disabled={ nextPage !== undefined ? 'false' : 'true' }
            disabled={ nextPage !== undefined ? false : true }
            className={ nextPage !== undefined ? '' : 'disabled' }
            onClick={
              () => dispatch({
                type: 'navigate',
                value: +1,
              })
            }
          >Next</button>
        </fieldset>

        <fieldset className="buttons bottom">
          {
            skippable &&
              <button
                type="button"
                className="link"
                onClick={
                  () => dispatch({ type: 'skip' })
                }
              >
                Skip this question
              </button>
          }
        </fieldset>
    </form>
  );
}

export default Questionnaire;
